"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _Button = require("../../components/Button/Button.styles");
var _LoadingMaskContent = require("../../components/LoadingMaskContent/LoadingMaskContent.styles");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var fluidCSS = function fluidCSS(mediaProps) {
  return (0, _styledComponents.css)(["width:", ";"], mediaProps.fluid ? '100%' : 'auto');
};
var disabledCSS = function disabledCSS(_ref) {
  var loading = _ref.loading;
  // Use default disabled styles when not in a loading state
  if (!loading) {
    return '';
  }
  return (0, _styledComponents.css)(["", ":disabled{transition:none;opacity:1;color:transparent;}"], _Button.StyledButton);
};

/** @class LoadingButtonMixin */
/** @method */
var LoadingButtonMixin = function LoadingButtonMixin(props) {
  return (0, _styledComponents.css)(["&,", "{", "}", ""], _LoadingMaskContent.StyledLoadingMaskContent, (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('fluid', fluidCSS)(props), disabledCSS(props));
};
exports.LoadingButtonMixin = LoadingButtonMixin;